import * as React from "react";

import dashboards from "./dashboards";

type Props = { name: string };

const SumoLogicDashboard: React.SFC<Props> = ({ name }) => {
  const config = dashboards.find(config => config.name === name);
  return (
    <iframe
      title="SumoLogic Dashboard"
      width="100%"
      height="100%"
      src={config.url}
    >
      <p>Your browser does not support iframes.</p>
    </iframe>
  );
};

export default SumoLogicDashboard;
